import { render, staticRenderFns } from "./FishListPercentage.vue?vue&type=template&id=71aedb38&scoped=true&"
import script from "./FishListPercentage.vue?vue&type=script&lang=js&"
export * from "./FishListPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aedb38",
  null
  
)

export default component.exports